/*LIBRARY*/
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { ArrowBackIos, Close } from "@material-ui/icons";
import pointsWithinPolygon from "@turf/points-within-polygon";
import { featureCollection } from "@turf/helpers";
import bbox from "@turf/bbox";

/*COMPONENT*/
import SolidCheckbox from "../reuseable/SolidCheckbox";
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*REDUX*/
import {
  get_poi_inside_polygon,
  set_value_toolbox,
  show_poi,
  status_toolbox,
  toolbox_handle_back,
  toolbox_handle_new_object,
  toolbox_handle_stop,
} from "../../App/actions/toolboxActions";

/*PICTURE*/
import icon_trash from "../../Assets/svg/icon_trash.svg";

/*FUNCTION*/
import { create_marker_element } from "../libre_layer/LAYER_TOOLBOX";
// import { get_mode_list } from "./TOOLBOX_TABLE";
import { get_toolbox_mode_list } from "../../App/validation/toolbox_mode_list";

/*HOOKS */
import useLanguage from "../common_hooks/useLanguage";
import Modal from "../common_modal/Modal";
import { array_to_sentence, parseRichText } from "../../App/validation/text_helper";
import {
  generateField,
  select_field_from_default_props,
} from "../../App/validation/generateGeoJson";
import {
  toolbox_save_layer,
  push_features,
  get_features_by_layer_id_without_reducer,
  remove_source_and_layer_from_map,
} from "../../App/actions/layerNewActions";
import { Dropdown } from "../reuseable";
import circle from "@turf/circle";
import uuid from "../../App/validation/uuid";
import { calculate_by_data_type } from "../../App/validation/data_types";
import POI_SELECTOR from "../reuseable/POI_SELECTOR";
import ProgressBarButton from "../reuseable/ProgressBarButton";
// import { is_user_get_access_by_license_key } from "../../App/actions/filter_license";
import { is_grid_already_covered, polygonsToDeduplicatedGrid } from "../../App/validation/geometry_helper";
import { snackbar } from "../../App/actions/snackbarActions";
import { post_activities } from "../../App/actions/activities";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*CONST*/

function TOOLBOX_DETAIL_RADIUS() {
  // hooks
  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  // global props
  const { map_object, geo_layer_list } = useSelector((state) => state.layer) || {};
  const project = useSelector((state) => state.project) || {};
  const point_layers = geo_layer_list.filter(l => l.geo_layer.type === "Point");
  const toolbox = useSelector((state) => state.toolbox) || {};
  const auth = useSelector((state) => state.auth) || {};
  const { geo_project } = useSelector((state) => state.project) || {};
  const insight_reducer = useSelector((state) => state.insight_reducer) || {};
  const {
    mode_toolbox,
    uuid_name,
    last_saved_feature_uuid,
    modal_cancel_confirmation,
    source_tab,
    default_radius_km,
    selected_poi_types,
    poi_inside_polygons,
    progress_get_data_poi,
    is_loading_get_data_poi,
    fields_poi_inside_polygon,
    layer_ids_poi,
    poi_fetched_layer_ids_per_radius,
    all_poi_features,
    start_time,
  } = toolbox || {};

  // naming
  const visible_name = mode_toolbox.replace("features", "visible");  // visible_radius
  const fields_toolbox = mode_toolbox.replace("features", "fields"); // fields_radius
  const source_id = "geojson_radius";

  const tool = get_toolbox_mode_list(mode_toolbox);
  const unit_options = tool?.unit_options || [];
  const visible_features = toolbox?.[visible_name];

  const fields = toolbox[fields_toolbox];
  const features = toolbox[mode_toolbox];
  const selected_row_toolbox_ids = toolbox[uuid_name];
  const selected_all =
    selected_row_toolbox_ids.length > 0
      ? !features.some((f) => !selected_row_toolbox_ids.includes(f.properties.uuid))
      : false;

  let last_saved_feature_uuid_index;
  if (last_saved_feature_uuid === "") last_saved_feature_uuid_index = Infinity;
  else if (last_saved_feature_uuid === "start") last_saved_feature_uuid_index = -1;
  else {
    // partial save
    last_saved_feature_uuid_index = features.findIndex(
      f => f.properties.uuid === last_saved_feature_uuid
    );
  }


  // local state
  const [unit, set_unit] = useState(unit_options?.[0] || "");
  const [layer_ids, set_layer_ids] = useState([]);
  const [modal_delete, set_modal_delete] = useState(false);
  const [modal_save_tool, set_modal_save_tool] = useState(false);
  const [modal_save_poi, set_modal_save_poi] = useState(false);
  const [new_layer_name, set_new_layer_name] = useState("");
  const [modal_mapid_data, set_modal_mapid_data] = useState(false);
  const selected_layers = geo_layer_list.filter(l => layer_ids.includes(l.geo_layer._id))
  // const is_has_access_sini = dispatch(
  //   is_user_get_access_by_license_key("license_sini_data")
  // );

  const abortRef = useRef(null);

  // functions
  const on_clear_select = () => {
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    const will_be_change_style = features.filter((f) =>
      visible_features.includes(f.properties.uuid),
    );
    if (!map_object) return;

    will_be_change_style.forEach((f) => {
      map_object.setFeatureState(
        { source: source_id, id: f.properties.uuid },
        { selected: false },
      );
    });
  };

  const on_select_row_uuid = async (uuid) => {
    const selected_row_toolbox_ids = toolbox[uuid_name];
    const willBeSelected = !selected_row_toolbox_ids.includes(uuid);

    // Update Redux
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: willBeSelected
          ? [...selected_row_toolbox_ids, uuid]
          : selected_row_toolbox_ids.filter((id) => id !== uuid),
      }),
    );

    // Set feature state sesuai state yang BARU
    map_object.setFeatureState(
      { source: source_id, id: uuid },
      { selected: willBeSelected }, // ✅ Langsung pake nilai baru
    );
  };

  const fly_to = (uuid) => {
    if (uuid) {
      const feature = toolbox[mode_toolbox].find(
        (item) => item?.properties?.uuid === uuid,
      );

      const radius = circle(feature, feature.properties.radius_km, {
        steps: 100,
        units: "kilometers",
        properties: feature.properties,
      })

      const geojson = featureCollection([radius]);
      const longitude = feature?.geometry?.coordinates?.[0];
      const latitude = feature?.geometry?.coordinates?.[1];
      if (map_object && longitude && latitude) {
        const bounds = bbox(geojson);
        map_object.flyTo({
          center: [longitude, latitude],
          speed: 1,
          zoom: map_object.cameraForBounds([
            [bounds[0], bounds[1]],
            [bounds[2], bounds[3]]
          ]).zoom
        });
      }
    }
  };

  const on_hide = (uuid) => {
    let visible_features = [...toolbox?.[visible_name]];
    if (visible_features.includes(uuid)) {
      visible_features = visible_features.filter((item) => item !== uuid);
    } else {
      visible_features.push(uuid);
    }

    if (!map_object) return;

    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: visible_features,
      }),
    );

    // polygon circle
    map_object.getSource(source_id)?.setData(
      featureCollection(
        features.filter((item) =>
          visible_features.includes(item.properties.uuid),
        ).map((feature_point) => {
          return circle(feature_point, feature_point.properties.radius_km, {
            steps: 100,
            units: "kilometers",
            properties: feature_point.properties,
          })
        })
      )
    );

    // label
    features.forEach((feature) => {
      if (visible_features.includes(feature.properties.uuid)) {
        create_marker_element({
          feature,
          uuid_active: feature.properties.uuid,
          map_object,
        });
      } else {
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${uuid}`,
        );
        if (marker_to_remove) {
          marker_to_remove.remove();
        }
      }
    });

    // ===============================================================

    dispatch(show_poi())
  };

  const on_delete = () => {
    const new_features = features.filter(
      (f) => !selected_row_toolbox_ids.includes(f.properties.uuid),
    );
    const new_visibles = visible_features.filter(
      (uuid) => !selected_row_toolbox_ids.includes(uuid),
    );

    let new_last = features.filter(
      (f, idx) =>
        last_saved_feature_uuid_index > idx &&
        !selected_row_toolbox_ids.includes(f.properties.uuid),
    );
    let new_last_uuid = new_last?.at(-1)?.properties?.uuid;
    if (new_last.length === 0) {
      new_last_uuid = "start";
    }

    // update yang di mapnya
    if (!map_object) return;

    // set features yang terlihat (dishow)
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: new_visibles,
      }),
    );

    // set features asli
    dispatch(
      set_value_toolbox({
        key: mode_toolbox,
        value: new_features,
      }),
    );

    const polygon_features_will_keep_features = new_features.map((feature_point) => {
      return circle(feature_point, feature_point.properties.radius_km, {
        steps: 100,
        units: "kilometers",
        properties: feature_point.properties,
      })
    })

    map_object.getSource(source_id)?.setData(
      featureCollection(polygon_features_will_keep_features)
    );

    let new_poi_inside_polygons = { ...poi_inside_polygons };

    // pakai Set biar lookup O(1)
    const selectedIdsSet = new Set(selected_row_toolbox_ids);

    // kumpulkan semua UUID POI yang akan dihapus
    const deletedPoiUuidSet = new Set();
    features.forEach((feature) => {
      if (!selected_row_toolbox_ids.includes(feature.properties.uuid)) return;

      const uuid = feature.properties.uuid;

      if (!selectedIdsSet.has(uuid)) return;

      // hapus marker
      const marker = document.getElementById(`marker_toolbox_${uuid}`);
      if (marker) marker.remove();

      // hapus layer map
      dispatch(remove_source_and_layer_from_map(`geojson_poi_${uuid}`));

      // ambil POI dalam polygon (guard biar aman)
      const pois = new_poi_inside_polygons[uuid] || [];
      pois.forEach(poi => deletedPoiUuidSet.add(poi.key));
      delete new_poi_inside_polygons[uuid];
    });

    // filter hanya sekali (lebih cepat)
    const new_all_poi_features = all_poi_features.filter(
      poi => !deletedPoiUuidSet.has(poi.key)
    );

    dispatch(set_value_toolbox({
      key: "all_poi_features",
      value: new_all_poi_features
    }))

    const source_id_poi = `geojson_poi`;
    if (map_object?.getSource(source_id_poi))
      map_object.getSource(source_id_poi).setData(featureCollection(new_all_poi_features));

    dispatch(set_value_toolbox({
      key: "poi_inside_polygons",
      value: new_poi_inside_polygons
    }))

    // set feature yang diselect
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    dispatch(
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: new_last_uuid,
      }),
    );

    set_modal_delete(false);
  };

  const on_hide_all = () => {
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: [],
      }),
    );

    if (map_object?.getSource(source_id)) {
      const geojson_polygon = featureCollection([])
      map_object.getSource(source_id)?.setData(geojson_polygon);
    }

    // label
    features.forEach((feature) => {
      const marker_to_remove = document.getElementById(
        `marker_toolbox_${feature?.properties?.uuid}`,
      );
      if (marker_to_remove) {
        marker_to_remove.remove();
      }
    });

    dispatch(show_poi());
  }

  const on_save = async () => {
    const properties = select_field_from_default_props("Polygon");
    const field_names_will_be_saved = [
      {
        name: "id_tool",
        type: "text",
      },
      {
        name: "radius_km",
        type: "number",
      },
      {
        name: "radius_m",
        type: "number",
      },
    ];

    const new_fields = [
      ...properties.concat(
        field_names_will_be_saved.map((i) => generateField(i.name, i.type, false))
      ),
      ...fields
    ];

    const body = {
      name: new_layer_name || "New Layer",
      description: "",
      type: "Polygon",
      folder: "",
      user_id: auth?.user?._id,
      geo_project_id: geo_project._id,
      fields: new_fields,
      properties,
      status: "digitasi",
      architecture: "v2",
      label_config: {
        is_use_label_text: true,
        is_use_label_image: false,
        label_text_field_key_array: [
          "id_tool"
        ],
        label_image_field_key_array: [],
        style_mode: "style_1",
        background_color_primary: "rgba(11, 217, 130, 1)",
        outline_color_primary: "rgba(0,0,0,0)",
        text_color_primary: "rgba(255, 255, 255, 1)",
        is_use_pin: false,
        text_stroke_width: 0,
        text_stroke_color: "rgba(255,255,255,1)",
        font_size: 11,
        font_weight: "bold",
        pin_height: 0
      },
    };

    let geo_layer = await dispatch(toolbox_save_layer(body));
    if (!geo_layer) return;

    const features_will_save = features
      .filter((f) => selected_row_toolbox_ids.includes(f.properties.uuid))
      .map((f) => {
        let new_properties = {};
        new_fields.forEach((i) => {
          new_properties[i.key] = f.properties[i.name]
        });

        return circle(f, f.properties.radius_km, {
          steps: 100,
          units: "kilometers",
          properties: new_properties,
        })

      });

    await dispatch(
      push_features({
        geo_layer_id: geo_layer?._id,
        features: features_will_save,
      }),
    );

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (start_time) await dispatch(post_activities({ action: `toolbox-${toolbox_type}-save-polygon`, duration_ms: new Date() - start_time }));

    set_modal_save_tool(false);
    set_new_layer_name("");

    on_clear_select();
    on_hide_all();

    const body_get = {
      geo_layer_id: geo_layer?._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      geo_layer_item: geo_layer,
    };
    dispatch(getDetailLayerById(body_get));
  };

  const assign_clusters_to_grouped_pois = (polygonData, groupedPOIData) => {
    // O(p) - Buat mapping UUID -> cluster ID
    const uuidToCluster = new Map();

    for (const polygon of polygonData) {
      const uuid = polygon.properties.uuid;
      const clusterId = polygon.properties.id_tool;

      if (!uuidToCluster.has(uuid)) {
        uuidToCluster.set(uuid, new Set());
      }
      uuidToCluster.get(uuid).add(clusterId);
    }

    // O(n) - Kumpulkan semua POI dengan cluster property
    const poiMap = new Map(); // untuk ensure uniqueness

    for (const [uuid, pois] of Object.entries(groupedPOIData)) {
      const clusters = uuidToCluster.get(uuid);

      // Skip jika uuid ini tidak ada di polygonData yang dipilih
      if (!clusters) continue;

      const clusterString = Array.from(clusters).sort().join('\n');

      for (const poi of pois) {
        const poiKey = `${poi.geometry.coordinates[0]},${poi.geometry.coordinates[1]}`;

        if (poiMap.has(poiKey)) {
          const existingPOI = poiMap.get(poiKey);
          const existingClusters = existingPOI.properties.cluster
            ? new Set(existingPOI.properties.cluster.split('\n'))
            : new Set();
          clusterString.split('\n').forEach(c => existingClusters.add(c));
          existingPOI.properties.cluster = Array.from(existingClusters).sort().join('\n');
        } else {
          poiMap.set(poiKey, {
            type: poi.type,
            geometry: poi.geometry,
            properties: {
              ...poi.properties,
              cluster: clusterString
            }
          });
        }
      }
    }

    // O(n) - Convert Map ke Array
    return Array.from(poiMap.values());
  }

  const on_save_poi = async () => {
    const filtered_polygon_features = features
      .filter(f => selected_row_toolbox_ids.includes(f.properties.uuid))
      .map((feature_point) => {
        return circle(feature_point, feature_point.properties.radius_km, {
          steps: 100,
          units: "kilometers",
          properties: feature_point.properties,
        })
      });

    // data poi diupdate untuk ditambahkan nama ID Tool jika masuk dalam area polygon
    const updated_poi_inside_polygons = assign_clusters_to_grouped_pois(
      filtered_polygon_features,
      poi_inside_polygons
    );

    const properties = select_field_from_default_props("Point");
    const field_names_will_be_saved = [
      {
        name: "cluster",
        type: "checklist",
      },
    ];

    const all_fields = [
      ...properties.concat(
        field_names_will_be_saved.map((i) => generateField(i.name, i.type, false))
      ),
      ...fields_poi_inside_polygon,
    ];


    const body = {
      name: new_layer_name || "New Layer",
      description: "",
      type: "Point",
      folder: "",
      user_id: auth?.user?._id,
      geo_project_id: geo_project._id,
      fields: all_fields,
      properties,
      status: "digitasi",
      architecture: "v2",
      // is_disable_download
      // label_config: {
      //   is_use_label_text: true,
      //   is_use_label_image: false,
      //   label_text_field_key_array: [
      //     "id_tool"
      //   ],
      //   label_image_field_key_array: [],
      //   style_mode: "style_1",
      //   background_color_primary: "rgba(11, 217, 130, 1)",
      //   outline_color_primary: "rgba(0,0,0,0)",
      //   text_color_primary: "rgba(255, 255, 255, 1)",
      //   is_use_pin: false,
      //   text_stroke_width: 0,
      //   text_stroke_color: "rgba(255,255,255,1)",
      //   font_size: 11,
      //   font_weight: "bold",
      //   pin_height: 25
      // },
    };



    let geo_layer = await dispatch(toolbox_save_layer(body));

    if (!geo_layer) return;
    const features_will_save = updated_poi_inside_polygons
      .map((f) => {
        let new_properties = {};
        all_fields.forEach((i) => {
          if (f?.properties?.[i.key])
            new_properties[i.key] = f.properties[i.key]
        });

        return {
          ...f,
          properties: new_properties,
        }

      });

    const limit = 50;

    for (let index = 0; index < features_will_save.length; index += limit) {
      const batch_features = features_will_save?.slice(index, index + limit);
      if (batch_features?.length === 0) break;

      // const progressPercent = parseInt((index / features_will_save.length) * limit);

      await dispatch(
        push_features({
          geo_layer_id: geo_layer?._id,
          features: batch_features,
        }),
      );
    }

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (start_time) await dispatch(post_activities({ action: `toolbox-${toolbox_type}-save-point`, duration_ms: new Date() - start_time }));

    set_modal_save_poi(false);
    set_new_layer_name("");

    on_clear_select();
    on_hide_all();

    const body_get = {
      geo_layer_id: geo_layer?._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      geo_layer_item: geo_layer,
    };
    dispatch(getDetailLayerById(body_get));
  };

  const on_select_all = () => {
    if (!selected_all) {
      const will_be_selected = features.map((f) => f.properties.uuid);
      dispatch(
        set_value_toolbox({
          key: uuid_name,
          value: will_be_selected,
        }),
      );

      const will_be_change_style = features.filter((f) =>
        visible_features.includes(f.properties.uuid),
      );
      if (!map_object) return;

      will_be_change_style.forEach((f) => {
        map_object.setFeatureState(
          { source: source_id, id: f.properties.uuid },
          { selected: true },
        );
      });
    } else {
      on_clear_select();
    }
  };

  const on_back = (value) => {
    let new_value = !modal_cancel_confirmation?.is_open;
    if (value === false || value === true) {
      new_value = value;
    }

    if (
      last_saved_feature_uuid_index < features.length
    ) {
      dispatch(
        set_value_toolbox({
          key: "modal_cancel_confirmation",
          value: {
            is_open: new_value,
            is_back_active: true,
            tab_value: "",
          },
        }),
      );
    } else {
      dispatch(toolbox_handle_back());
    }
  }

  const set_source_tab = (value) => {
    dispatch(
      set_value_toolbox({
        key: "source_tab",
        value,
      }),
    );

    if (value === 1) {
      dispatch(toolbox_handle_stop());
    } else {
      dispatch(toolbox_handle_new_object());
    }
  }

  const enter_id = (id) => {
    if (layer_ids.includes(id)) {
      set_layer_ids(layer_ids.filter(i => i !== id))
    } else {
      set_layer_ids([...layer_ids, id])
    }
  }

  // const remove_selected_poi_type = (i) => {
  //   const temp_name = i.split("-");
  //   const tipe1 = temp_name[0].replace(/_/g, ' ').trim();
  //   const tipe2 = temp_name[1]?.replace(/_/g, ' ').trim();
  //   const tipe3 = temp_name[2]?.replace(/_/g, ' ').trim();

  //   if (tipe3) {
  //     const new_tipe_3 = selected_poi_types.tipe_3.filter(j => j !== i);
  //     dispatch(set_value_toolbox({
  //       key: "selected_poi_types",
  //       value: {
  //         ...selected_poi_types,
  //         tipe_3: new_tipe_3
  //       }
  //     }));
  //   } else if (tipe2) {
  //     const new_tipe_2 = selected_poi_types.tipe_2.filter(j => j !== i);
  //     dispatch(set_value_toolbox({
  //       key: "selected_poi_types",
  //       value: {
  //         ...selected_poi_types,
  //         tipe_2: new_tipe_2
  //       }
  //     }));
  //   } else if (tipe1) {
  //     const new_tipe_1 = selected_poi_types.tipe_1.filter(j => j !== i);
  //     dispatch(set_value_toolbox({
  //       key: "selected_poi_types",
  //       value: {
  //         ...selected_poi_types,
  //         tipe_1: new_tipe_1
  //       }
  //     }));
  //   }

  // }

  const get_features = async () => {
    const project_id = project?.geo_project?._id;
    let result_features = [];
    let new_fields = []


    let field_keys = new Map();
    for (const layer of selected_layers) {
      // get data
      const geo_layer_id = layer?.geo_layer?._id;
      const architecture = layer?.geo_layer?.architecture;
      const new_features = await dispatch(
        get_features_by_layer_id_without_reducer({
          project_id,
          geo_layer_id,
          architecture
        })
      )

      // merge features      
      result_features = [...result_features, ...new_features];

      // merge fields tanpa tipe style
      layer?.geo_layer?.fields.forEach(field => {
        if (field?.isStyle !== true || field?.isStyle === undefined) {
          if (field_keys.has(field.key)) {
            const existingObj = field_keys.get(field.key);
            Object.assign(existingObj, field);
          } else {
            field_keys.set(field.key, field);
          }
        }
      });
    }

    new_fields = Array.from(field_keys.values());


    const geojson_features = [];
    const visible_ids = []
    result_features = result_features.map((f, idx) => {

      const calculated_feature = calculate_by_data_type({
        feature: f,
        fields: new_fields,
      });

      const new_uuid = uuid();
      visible_ids.push(new_uuid);
      let new_properties = {
        uuid: new_uuid,
        radius_km: default_radius_km,
        radius_m: default_radius_km * 1000,
        id_tool: `R-${idx + 1}`
      }

      new_fields.forEach((data) => {
        new_properties[data.name] = calculated_feature.properties[data.key];
      });

      // polygon circle
      geojson_features.push(
        {
          ...circle(calculated_feature, default_radius_km, {
            steps: 100,
            units: "kilometers",
            properties: new_properties,
          }),
          id: new_uuid,
        }
      )

      // point
      return {
        ...calculated_feature,
        id: new_uuid,
        properties: new_properties
      }
    })

    // data point disimpan
    dispatch(set_value_toolbox({
      key: mode_toolbox,
      value: result_features,
    }))

    const geojson = featureCollection(geojson_features)

    // data polygon circle di tampilkan
    const rendered_radius = map_object.getSource(source_id);
    if (rendered_radius) {
      rendered_radius.setData(geojson)
    } else {
      map_object.addSource(source_id, {
        type: "geojson",
        data: geojson,
      });
    }

    dispatch(set_value_toolbox({
      key: fields_toolbox,
      value: new_fields,
    }))
    // visible
    dispatch(set_value_toolbox({
      key: visible_name,
      value: visible_ids,
    }))
    // selected
    dispatch(set_value_toolbox({
      key: uuid_name,
      value: visible_ids,
    }))

    dispatch(status_toolbox())

  }

  const set_selected_poi_types = (value) => {
    dispatch(set_value_toolbox({
      key: "selected_poi_types",
      value: value
    }));
  }

  const generate_color_expression = (tipe_1_array) => {
    const expression = ['match', ['get', 'TIPE_1']];

    tipe_1_array.forEach(item => {
      expression.push(item.TIPE_1, item.color);
    });

    expression.push('#000000'); // default/fallback color

    return expression;
  }

  // const get_features_poi = async () => {
  //   if (is_loading_get_data_poi) return;

  //   if (abortRef.current) {
  //     abortRef.current.abort();
  //   }

  //   const controller = new AbortController();
  //   abortRef.current = controller;

  //   const selectedIds = new Set(selected_row_toolbox_ids);
  //   const selected_features = features.filter(f => {
  //     return selectedIds.has(f.properties.uuid)
  //   });

  //   dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 0 }))
  //   dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: true }))

  //   // ✅ Yield ke browser dulu supaya loading bar langsung kerender
  //   await new Promise(resolve => setTimeout(resolve, 0));

  //   const selected_polygon_features = [];
  //   for (const feature of selected_features) {
  //     const center = feature?.geometry?.coordinates;
  //     const radius = feature?.properties?.radius_km;
  //     const options = { steps: 100, units: "kilometers", properties: feature?.properties };
  //     selected_polygon_features.push(circle(center, radius, options))
  //   };

  //   // ── Cek polygon mana yang sudah pernah di-fetch sebelumnya ──
  //   const current_layer_ids_sorted = [...layer_ids_poi].sort().join(",");
  //   const already_fetched_uuids = new Set(
  //     selected_features
  //       .filter(f => {
  //         const uuid = f.properties.uuid;
  //         if (!Array.isArray(poi_inside_polygons?.[uuid])) return false;

  //         const prev = poi_fetched_layer_ids_per_radius?.[uuid];
  //         if (!prev) return false;

  //         return [...prev].sort().join(",") === current_layer_ids_sorted;
  //       })
  //       .map(f => f.properties.uuid)
  //   );

  //   // Kalau semua polygon sudah ke-fetch, skip total
  //   if (already_fetched_uuids.size === selected_features.length) {
  //     console.log("Semua polygon sudah pernah di-fetch, skip.");
  //     dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 100 }))
  //     dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }))
  //     return;
  //   }

  //   const poi_features = [];
  //   const grids = polygonsToDeduplicatedGrid(selected_polygon_features, 2, "kilometers");

  //   let failed_grids = [];
  //   let fields_poi_set = false;

  //   // Carry over data yang sudah ada dari state
  //   let new_poi_inside_polygons = { ...poi_inside_polygons };

  //   const fetched_uuids = () => new Set(Object.keys(new_poi_inside_polygons));

  //   // ── PASS 1: loop semua grid, skip yang gagal atau sudah ke-cover ──
  //   const seenPoiKeys = new Set();
  //   for (const [index, feature] of grids.entries()) {
  //     if (controller.signal.aborted) break;

  //     // Skip grid yang semua polygon-nya sudah ke-fetch sebelumnya
  //     if (is_grid_already_covered(feature, selected_polygon_features, already_fetched_uuids)) {
  //       dispatch(set_value_toolbox({
  //         key: "progress_get_data_poi",
  //         value: parseInt(((index + 1) / grids.length) * 80)
  //       }))
  //       continue;
  //     }

  //     try {
  //       const { features: features_poi, fields: fields_poi } = await dispatch(get_poi_inside_polygon({
  //         feature,
  //         geo_layer_ids: layer_ids_poi,
  //         poi_source: "layer",
  //       }))

  //       if (controller.signal.aborted) break;

  //       const poi_collection_so_far = featureCollection(features_poi);
  //       selected_polygon_features.forEach(polygon => {
  //         const inside = pointsWithinPolygon(poi_collection_so_far, polygon)?.features || [];

  //         if (inside.length > 0) {
  //           const existing = new_poi_inside_polygons[polygon.properties.uuid] || [];

  //           for (const poi of inside) {
  //             const key = `${poi.geometry.coordinates[0]},${poi.geometry.coordinates[1]}`;
  //             if (!seenPoiKeys.has(key)) {
  //               seenPoiKeys.add(key);
  //               poi_features.push(poi);
  //             }
  //             existing.push(poi);
  //           }

  //           new_poi_inside_polygons[polygon.properties.uuid] = existing;
  //         }
  //       });

  //       if (!fields_poi_set) {
  //         dispatch(set_value_toolbox({ key: "fields_poi_inside_polygon", value: fields_poi }))
  //         fields_poi_set = true;
  //       }
  //     } catch (err) {
  //       if (controller.signal.aborted) break;
  //       failed_grids.push(feature);
  //       console.warn(`Grid ${index} gagal, akan diretry nanti`, err);
  //     }

  //     dispatch(set_value_toolbox({
  //       key: "progress_get_data_poi",
  //       value: parseInt(((index + 1) / grids.length) * 80)
  //     }))
  //   }

  //   // ── PASS 2: retry failed_grids sampai semua berhasil ──
  //   const MAX_RETRY = 5;
  //   let retry_attempt = 0;
  //   while (failed_grids.length > 0 && !controller.signal.aborted && retry_attempt < MAX_RETRY) {
  //     retry_attempt++;
  //     console.log(`Retry attempt ${retry_attempt}, sisa ${failed_grids.length} grid gagal`);

  //     const still_failing = [];

  //     for (const [index, feature] of failed_grids.entries()) {
  //       if (controller.signal.aborted) break;

  //       if (is_grid_already_covered(feature, selected_polygon_features, fetched_uuids())) {
  //         continue;
  //       }

  //       try {
  //         const { features: features_poi, fields: fields_poi } = await dispatch(get_poi_inside_polygon({
  //           feature,
  //           geo_layer_ids: layer_ids_poi,
  //           poi_source: "layer",
  //         }))

  //         if (controller.signal.aborted) break;

  //         const poi_collection_so_far = featureCollection(features_poi);
  //         selected_polygon_features.forEach(polygon => {
  //           const inside = pointsWithinPolygon(poi_collection_so_far, polygon)?.features || [];
  //           if (inside.length > 0) {
  //             const existing = new_poi_inside_polygons[polygon.properties.uuid] || [];
  //             for (const poi of inside) {
  //               const key = `${poi.geometry.coordinates[0]},${poi.geometry.coordinates[1]}`;
  //               if (!seenPoiKeys.has(key)) {
  //                 seenPoiKeys.add(key);
  //                 poi_features.push(poi);
  //               }
  //               existing.push(poi);
  //             }
  //           }
  //         });

  //         if (!fields_poi_set) {
  //           dispatch(set_value_toolbox({ key: "fields_poi_inside_polygon", value: fields_poi }))
  //           fields_poi_set = true;
  //         }
  //       } catch (err) {
  //         if (controller.signal.aborted) break;
  //         still_failing.push(feature);
  //         console.warn(`Grid masih gagal di attempt ${retry_attempt}`, err);
  //       }

  //       dispatch(set_value_toolbox({
  //         key: "progress_get_data_poi",
  //         value: parseInt(80 + ((index + 1) / failed_grids.length) * 15)
  //       }))
  //     }

  //     failed_grids = still_failing;

  //     if (failed_grids.length > 0 && !controller.signal.aborted) {
  //       const delay = 1000 * retry_attempt;
  //       await new Promise(resolve => setTimeout(resolve, delay));
  //     }
  //   }

  //   if (failed_grids.length > 0) {
  //     dispatch(snackbar({
  //       message: `${failed_grids.length} grid gagal setelah ${MAX_RETRY} kali retry`,
  //       status: "warning",
  //       is_open: true,
  //     }))
  //   }

  //   // ── Kalau di-abort → stop total ──
  //   if (controller.signal.aborted) {
  //     dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 100 }));
  //     dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }));
  //     abortRef.current = null;
  //     return;
  //   }

  //   // ── Filter akhir pakai polygon asli, rebuild new_poi_inside_polygons bersih ──
  //   const poi_collection_raw = featureCollection(poi_features);
  //   const filtered_poi_features = [...all_poi_features];

  //   // Reset hanya untuk polygon yang baru di-fetch
  //   selected_polygon_features.forEach(polygon => {
  //     if (already_fetched_uuids.has(polygon.properties.uuid)) {
  //       // Sudah ada dari sebelumnya, carry over aja
  //       const existing = poi_inside_polygons?.[polygon.properties.uuid] || [];
  //       filtered_poi_features.push(...existing);
  //       return;
  //     }
  //     const inside = pointsWithinPolygon(poi_collection_raw, polygon)?.features || [];
  //     new_poi_inside_polygons[polygon.properties.uuid] = inside;
  //     filtered_poi_features.push(...inside);
  //   });

  //   // Deduplicate
  //   const seen = new Set();
  //   const unique_poi_features = filtered_poi_features.filter(f => {
  //     const [lng, lat] = f.geometry.coordinates;
  //     const key = `${lng},${lat}`;
  //     if (seen.has(key)) return false;
  //     seen.add(key);
  //     return true;
  //   });

  //   dispatch(set_value_toolbox({ key: "all_poi_features", value: unique_poi_features }))

  //   const poi_collection = featureCollection(unique_poi_features)

  //   dispatch(set_value_toolbox({ key: "poi_inside_polygons", value: new_poi_inside_polygons }))

  //   const source_id_poi = `geojson_poi`;
  //   const rendered_radius = map_object.getSource(source_id_poi);

  //   if (rendered_radius) {
  //     rendered_radius.setData(poi_collection)
  //   } else {
  //     const { list_tipe_1 } = insight_reducer || {};

  //     map_object.addSource(source_id_poi, {
  //       type: "geojson",
  //       data: poi_collection,
  //       cluster: false,
  //     });

  //     map_object.addLayer({
  //       id: source_id_poi,
  //       type: "circle",
  //       source: source_id_poi,
  //       paint: {
  //         "circle-color": generate_color_expression(list_tipe_1 || []),
  //         "circle-radius": 5,
  //         "circle-stroke-width": 2,
  //         "circle-stroke-color": "#fff",
  //       },
  //       layout: { visibility: "visible" },
  //     });
  //   }

  //   dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 90 }))

  //   const updated_poi_fetched_layer_ids = { ...poi_fetched_layer_ids_per_radius };
  //   selected_features.forEach(point => {
  //     if (!already_fetched_uuids.has(point.properties.uuid)) {
  //       updated_poi_fetched_layer_ids[point.properties.uuid] = [...layer_ids_poi];
  //     }
  //   });
  //   dispatch(set_value_toolbox({
  //     key: "poi_fetched_layer_ids_per_radius",
  //     value: updated_poi_fetched_layer_ids
  //   }))

  //   dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 100 }))
  //   dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }))
  // }

  const normalizeIds = (arr) => arr?.slice().sort().join(",");

  const setProgress = (dispatch, value) => {
    dispatch(set_value_toolbox({
      key: "progress_get_data_poi",
      value
    }));
  };

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  const processPOIsIntoPolygons = ({
    features_poi,
    polygons,
    seenPoiKeys,
    poi_features,
    new_poi_inside_polygons
  }) => {
    const collection = featureCollection(features_poi);

    polygons.forEach(polygon => {
      const inside = pointsWithinPolygon(collection, polygon)?.features || [];
      if (!inside.length) return;

      const uuid = polygon.properties.uuid;
      const existing = new_poi_inside_polygons[uuid] || [];

      for (const poi of inside) {
        const [lng, lat] = poi.geometry.coordinates;
        const key = `${lng},${lat}`;

        if (!seenPoiKeys.has(key)) {
          seenPoiKeys.add(key);
          poi_features.push(poi);
        }

        existing.push(poi);
      }

      new_poi_inside_polygons[uuid] = existing;
    });
  };

  const get_features_poi = async () => {
    if (is_loading_get_data_poi) return;

    if (abortRef.current) abortRef.current.abort();

    const controller = new AbortController();
    abortRef.current = controller;

    dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 0 }));
    dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: true }));

    await delay(0);

    const selectedIds = new Set(selected_row_toolbox_ids);
    const selected_features = features.filter(f =>
      selectedIds.has(f.properties.uuid)
    );

    // const selected_polygons = selected_features.map(f =>
    //   circle(
    //     f?.geometry?.coordinates,
    //     f?.properties?.radius_km,
    //     { steps: 100, units: "kilometers", properties: f.properties }
    //   )
    // );

    const currentLayerKey = normalizeIds(layer_ids_poi);

    const already_fetched_uuids = new Set(
      selected_features
        .filter(f => {
          const uuid = f.properties.uuid;
          if (!Array.isArray(poi_inside_polygons?.[uuid])) return false;

          const prev = poi_fetched_layer_ids_per_radius?.[uuid];
          if (!prev) return false;

          return normalizeIds(prev) === currentLayerKey;
        })
        .map(f => f.properties.uuid)
    );

    if (already_fetched_uuids.size === selected_features.length) {
      setProgress(dispatch, 100);
      dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }));
      return;
    }

    let selected_polygons = [];
    let selected_polygons_wo_already_fetched = []
    selected_features.forEach(f => {
      const polygon = circle(
        f?.geometry?.coordinates,
        f?.properties?.radius_km,
        { steps: 100, units: "kilometers", properties: f.properties }
      );

      if (!already_fetched_uuids.has(f.properties.uuid)) {
        selected_polygons_wo_already_fetched.push(polygon)
      }
      selected_polygons.push(polygon);
    });

    const grids = polygonsToDeduplicatedGrid(selected_polygons, 2, "kilometers");

    let failed_grids = [];
    let fields_poi_set = false;

    const poi_features = [];
    const seenPoiKeys = new Set();

    let new_poi_inside_polygons = { ...poi_inside_polygons };

    const fetchGrid = async (feature, is_get_fields) => {
      return await dispatch(get_poi_inside_polygon({
        feature,
        geo_layer_ids: layer_ids_poi,
        poi_source: "layer",
        is_get_fields
      }));
    };

    // ===== PASS 1 =====
    for (const [index, feature] of grids.entries()) {
      if (controller.signal.aborted) break;

      if (is_grid_already_covered(feature, selected_polygons, already_fetched_uuids)) {
        setProgress(dispatch, parseInt(((index + 1) / grids.length) * 80));
        continue;
      }

      try {
        const { features: features_poi, fields: fields_poi } = await fetchGrid(feature, !fields_poi_set);
        if (!fields_poi_set) {
          dispatch(set_value_toolbox({ key: "fields_poi_inside_polygon", value: fields_poi }));
          fields_poi_set = true;
        }

        processPOIsIntoPolygons({
          features_poi,
          polygons: selected_polygons_wo_already_fetched,
          seenPoiKeys,
          poi_features,
          new_poi_inside_polygons
        });


      } catch (err) {
        failed_grids.push(feature);
      }

      setProgress(dispatch, parseInt(((index + 1) / grids.length) * 80));
    }

    // ===== RETRY =====
    const MAX_RETRY = 5;
    let attempt = 0;

    while (failed_grids.length && attempt < MAX_RETRY && !controller.signal.aborted) {
      attempt++;
      const next_failed = [];

      for (const [index, feature] of failed_grids.entries()) {
        if (controller.signal.aborted) break;

        try {
          const { features: features_poi, fields: fields_poi } = await fetchGrid(feature);

          processPOIsIntoPolygons({
            features_poi,
            polygons: selected_polygons_wo_already_fetched,
            seenPoiKeys,
            poi_features,
            new_poi_inside_polygons
          });

          if (!fields_poi_set) {
            dispatch(set_value_toolbox({ key: "fields_poi_inside_polygon", value: fields_poi }));
            fields_poi_set = true;
          }
        } catch {
          next_failed.push(feature);
        }

        setProgress(dispatch, parseInt(80 + ((index + 1) / failed_grids.length) * 15));
      }

      failed_grids = next_failed;

      if (failed_grids.length) {
        await delay(1000 * attempt);
      }
    }

    if (failed_grids.length > 0) {
      dispatch(snackbar({
        message: `${failed_grids.length} grid gagal setelah ${MAX_RETRY} kali retry`,
        status: "warning",
        is_open: true,
      }))
    }

    if (controller.signal.aborted) {
      setProgress(dispatch, 100);
      dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }));
      abortRef.current = null;
      return;
    }

    // ===== FINALIZE =====
    const poi_collection_raw = featureCollection(poi_features);
    const filtered = [...all_poi_features];

    selected_polygons_wo_already_fetched.forEach(polygon => {
      const uuid = polygon.properties.uuid;

      if (already_fetched_uuids.has(uuid)) {
        filtered.push(...(poi_inside_polygons?.[uuid] || []));
        return;
      }

      const inside = pointsWithinPolygon(poi_collection_raw, polygon)?.features || [];
      new_poi_inside_polygons[uuid] = inside;
      filtered.push(...inside);
    });

    const seen = new Set();
    const unique = filtered.filter(f => {
      const [lng, lat] = f.geometry.coordinates;
      const key = `${lng},${lat}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    dispatch(set_value_toolbox({ key: "all_poi_features", value: unique }));
    dispatch(set_value_toolbox({ key: "poi_inside_polygons", value: new_poi_inside_polygons }));

    const poi_collection = featureCollection(unique);
    const source_id = "geojson_poi";

    const existing = map_object.getSource(source_id);

    if (existing) {
      existing.setData(poi_collection);
    } else {
      const { list_tipe_1 } = insight_reducer || {};

      map_object.addSource(source_id, {
        type: "geojson",
        data: poi_collection,
        cluster: false,
      });

      map_object.addLayer({
        id: source_id,
        type: "circle",
        source: source_id,
        paint: {
          "circle-color": generate_color_expression(list_tipe_1 || []),
          "circle-radius": 5,
          "circle-stroke-width": 2,
          "circle-stroke-color": "#fff",
        },
        layout: { visibility: "visible" },
      });
    }

    const updated = { ...poi_fetched_layer_ids_per_radius };
    selected_features.forEach(f => {
      if (!already_fetched_uuids.has(f.properties.uuid)) {
        updated[f.properties.uuid] = [...layer_ids_poi];
      }
    });

    dispatch(set_value_toolbox({
      key: "poi_fetched_layer_ids_per_radius",
      value: updated
    }));

    setProgress(dispatch, 100);
    dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }));
  };

  const deleted_list = features.reduce(function (result, feature) {
    if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
      return result.concat(feature.properties.id_tool);
    }
    return result;
  }, []);

  // content
  const modal_delete_content = modal_delete && (
    <Modal
      isOpen={modal_delete}
      onClose={() => set_modal_delete(false)}
      modalSize="small"
      title="Confirmation"
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px", maxHeight: "400px", overflowY: "auto" }}>
        <p style={{ display: "inline" }}>{dict["Are you sure to delete"][language]}{` `}</p>
        <p style={{ display: "inline", fontWeight: 700, fontSize: "18px" }}>
          {deleted_list && array_to_sentence(deleted_list, "eng")}
        </p>
        <p style={{ display: "inline" }}>{`?`}</p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "15px",
        }}
      >
        <button
          onClick={() => set_modal_delete(false)}
          className="button_pill button_white"
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_delete()}
          className="button_pill flex"
          style={{
            backgroundColor: "#BD0000",
            color: "white",
          }}
        >
          <img src={icon_trash} alt="Delete" />
          {dict["Delete"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_save_content = modal_save_tool && (
    <Modal
      isOpen={modal_save_tool}
      onClose={() => set_modal_save_tool(false)}
      modalSize="small"
      title={dict["Give a name"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px" }}>
        <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
          {dict["Layer Name"][language]}
        </p>
      </div>

      <div style={{ marginBottom: "25px" }}>
        <input
          type="text"
          style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
          value={new_layer_name}
          onChange={(e) => set_new_layer_name(e.target.value)}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          onClick={() => set_modal_save_tool(false)}
          className="button_pill flex"
          style={{
            border: "1px solid black",
            color: "black",
          }}
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_save()}
          className="button_pill flex"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          {dict["Save"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_save_poi_content = modal_save_poi && (
    <Modal
      isOpen={modal_save_poi}
      onClose={() => set_modal_save_poi(false)}
      modalSize="small"
      title={dict["Give a name"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px" }}>
        <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
          {dict["Layer Name"][language]}
        </p>
      </div>

      <div style={{ marginBottom: "25px" }}>
        <input
          type="text"
          style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
          value={new_layer_name}
          onChange={(e) => set_new_layer_name(e.target.value)}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          onClick={() => set_modal_save_poi(false)}
          className="button_pill flex"
          style={{
            border: "1px solid black",
            color: "black",
          }}
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_save_poi()}
          className="button_pill flex"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          {dict["Save"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_mapid_data_content = modal_mapid_data && (
    <Modal
      isOpen={modal_mapid_data}
      onClose={() => set_modal_mapid_data(false)}
      modalSize="small"
      title={"Select MAPID Data"}
      is_hide="hide"
    >

      <POI_SELECTOR
        get_value={set_selected_poi_types}
        selected_poi_types={selected_poi_types}
      />
    </Modal>
  );

  const selected_pill = (key, label, callback) => {
    const name = label.replace(/_/g, " ");
    return <div
      key={key}
      className="label_pill"
      title={name}
      style={{
        border: "1px solid #ABABAB80",
        backgroundColor: "#F1F1F1",
        textWrap: "nowrap",
      }}
    >
      <span
        style={{
          maxWidth: "180px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {name}
      </span>
      <button
        className="center_perfect"
        onClick={() => callback(key)}
        style={{
          borderRadius: "100%",
          border: "1px solid black",
          width: "14px",
          height: "14px",
        }}>
        <Close style={{ width: "10px", height: "10px" }} />
      </button>
    </div>
  }

  const update_poi_inside_polygons = (id) => {
    if (layer_ids_poi.includes(id)) {
      dispatch(set_value_toolbox({
        key: "layer_ids_poi",
        value: layer_ids_poi.filter(i => i !== id)
      }))
    } else {
      dispatch(set_value_toolbox({
        key: "layer_ids_poi",
        value: [...layer_ids_poi, id]
      }))
    }
  }

  const clear_data_poi = () => {
    const source_id_poi = `geojson_poi`;
    dispatch(set_value_toolbox({ key: "poi_inside_polygons", value: {} }));
    dispatch(set_value_toolbox({ key: "all_poi_features", value: [] }));

    if (abortRef.current) abortRef.current.abort();

    dispatch(set_value_toolbox({ key: "poi_fetched_layer_ids_per_radius", value: {} }))
    dispatch(set_value_toolbox({ key: "all_poi_features", value: [] }))
    dispatch(set_value_toolbox({ key: "progress_get_data_poi", value: 0 }));
    dispatch(set_value_toolbox({ key: "is_loading_get_data_poi", value: false }));

    if (map_object?.getLayer(source_id_poi))
      map_object.removeLayer(source_id_poi);

    if (map_object?.getSource(source_id_poi))
      map_object.removeSource(source_id_poi);
  }

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 20px 25px 20px",
        }}
      >
        <button
          onClick={() => on_back(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: 700,
            width: "fit-content",
            padding: "2px 10px",
            borderRadius: "2px",
          }}
        >
          <ArrowBackIos style={{ fontSize: "12px" }} />
          {dict["Back to Menu"][language]}
        </button>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "0 27px"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#F5F5F5",
            padding: "6px 8px",
            borderRadius: "15px"
          }}
        >
          <div
            className='center_perfect'
            style={{
              width: "160px",
              height: "29px",
              borderRadius: "5px",
              backgroundColor: source_tab === 0 ? "#fff" : "#ffffff00",
              fontWeight: source_tab === 0 ? "700" : "400",
              cursor: "pointer",
              fontSize: "14px"
            }}
            onClick={() => set_source_tab(0)}
          >
            {dict["Create Point"][language]}
          </div>
          <div
            className='center_perfect'
            style={{
              width: "160px",
              height: "29px",
              borderRadius: "5px",
              backgroundColor: source_tab === 1 ? "#fff" : "#ffffff00",
              fontWeight: source_tab === 1 ? "700" : "400",
              cursor: "pointer",
              fontSize: "14px"
            }}
            onClick={() => set_source_tab(1)}
          >
            {dict["Select Layer"][language]}
          </div>
        </div>

        {source_tab === 1 &&
          <>
            <div
              style={{
                border: "1px solid #D3B572",
                backgroundColor: "#FFFAEC",
                padding: "8px 16px",
                borderRadius: "20px",
                fontSize: "12px",
                color: "#6C5D3A"
              }}
            >
              {parseRichText(dict["Select at least one Point Layer to filter the objects."][language])}
            </div>

            <div style={{ display: 'flex', flexDirection: "column", gap: "10px" }}>
              <span >{dict["Select Layer"][language]} (Point)</span>
              <Dropdown
                placeholder={dict["Select"][language]}
                filter_on
                is_enable_empty={false}
                onChange={(value) => {
                  enter_id(value);
                }}
              >
                {point_layers?.map((layer) => {
                  return (
                    <option key={layer?.geo_layer?._id} value={layer?.geo_layer?._id}>
                      {layer?.geo_layer?.name}
                    </option>
                  );
                })}
              </Dropdown>
            </div>

            {selected_layers?.length > 0 && <div
              style={{
                display: "flex",
                maxHeight: "100px",
                overflowY: "auto",
                gap: "5px",
                width: "230px",
                flexWrap: "wrap",
              }}
            >
              {
                selected_layers.map(i => (
                  <div
                    key={i.geo_layer._id}
                    className="label_pill"
                    style={{
                      border: "1px solid #ABABAB80",
                      backgroundColor: "#F1F1F1",
                      textWrap: "nowrap",
                    }}
                    title={i.geo_layer?.name}
                  >
                    <span
                      style={{
                        maxWidth: "180px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {i.geo_layer?.name}
                    </span>
                    <button
                      className="center_perfect"
                      onClick={() => enter_id(i.geo_layer._id)}
                      style={{
                        borderRadius: "100%",
                        border: "1px solid black",
                        width: "14px",
                        height: "14px",
                      }}>
                      <Close style={{ width: "10px", height: "10px" }} />
                    </button>
                  </div>
                ))
              }
            </div>}

            <div>
              <button
                className="label_pill"
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  height: "40px"
                }}
                onClick={() => get_features()}
              >
                {dict["Choose"][language]}
              </button>
            </div>
          </>}

        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Results"][language]}</span>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {dict["The area resulting from the combination of the selected layers and the new polygon has been successfully calculated."][language]}
          </p>
        </div>
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "20px 0px 15px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            margin: "0px 27px 0px 27px",
          }}
        >
          <label
            style={{ fontWeight: 700, fontSize: "0.875rem", color: "#B2B2B2" }}
          >
            {dict["Table"][language]}
          </label>
          <Select
            style={{
              height: "28px",
              marginLeft: "10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
            value={unit}
            onChange={(e) => set_unit(e.target.value)}
          >
            {unit_options.map((unit, idx) => {
              return (
                <MenuItem key={idx} value={unit}>
                  {unit}
                </MenuItem>
              );
            })}
          </Select>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "10px",
            margin: "0 27px 0px 27px",
          }}
        >
          <SolidCheckbox
            id="select_all"
            checked={selected_all}
            onChange={() => on_select_all()}
            style={{ width: "18px", height: "18px", cursor: "pointer" }}
          />
          <label
            htmlFor="select_all"
            style={{ fontSize: "14px", cursor: "pointer" }}
          >
            {dict["Select All"][language]}
          </label>
        </div>

        {features.length > 0 && mode_toolbox !== "grouping" && (
          <div
            style={{ maxHeight: "200px", overflowY: "auto", position: "relative" }}
          >
            <table className="toolbox_table"
            >
              <thead>
                <tr>
                  <th>{dict["Select"][language]}</th>
                  <th>No.</th>
                  <th>ID Tool</th>
                  <th>{dict["Radius"][language]}</th>
                  {
                    fields.map(field => (
                      <th
                        key={field.key}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {field.name}</th>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {features.map((item, idx) => {
                  const viewStatus = visible_features.includes(item.properties.uuid);

                  return (
                    <React.Fragment key={idx}>
                      <tr
                        style={{ backgroundColor: last_saved_feature_uuid_index < idx ? "lightGrey" : "white" }}
                        onClick={() => fly_to(item.properties.uuid)}
                      >
                        <td style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "center" }}>
                          <SolidCheckbox
                            checked={selected_row_toolbox_ids.includes(
                              item.properties.uuid,
                            )}
                            onChange={() =>
                              on_select_row_uuid(item.properties.uuid)
                            }
                            style={{ width: "18px", height: "18px" }}
                          />
                          <button
                            style={{
                              color: "black",
                            }}
                            onClick={() => on_hide(item.properties.uuid)}
                          >
                            <ICON_VIEW
                              color={viewStatus ? "#000" : "#b7b7b7"}
                              strokeWidth={viewStatus ? 4 : 3}
                              style={{ width: "18px", height: "18px" }}
                            />
                          </button>
                        </td>

                        <td>{idx + 1}</td>
                        <td>{item?.properties?.id_tool}</td>
                        <td>
                          {unit === "meter"
                            ? Intl.NumberFormat("id-ID").format(
                              item?.properties?.radius_m,
                            )
                            : Intl.NumberFormat("id-ID").format(
                              item?.properties?.radius_km,
                            )}
                        </td>
                        {
                          fields.map(field => (
                            <td
                              key={`${field.key}_${item?.properties?.uuid}`}
                              style={{
                                maxWidth: "100px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >{item?.properties?.[field.name]}</td>
                          ))
                        }

                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {selected_row_toolbox_ids?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <button
              onClick={() => on_clear_select()}
              className="button_pill button_white"
            >
              {dict["Cancel"][language]}
            </button>
            <button
              onClick={() => set_modal_delete(true)}
              className="button_pill flex"
              style={{
                backgroundColor: "#BD0000",
                color: "white",
              }}
            >
              <img src={icon_trash} alt="Delete" />
              {dict["Delete"][language]}
            </button>
            <button
              onClick={() => set_modal_save_tool(true)}
              title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Polygons"][language]}`}
              className="button_pill flex"
              style={{
                backgroundColor: "black",
                color: "white",
              }}
            >
              {dict["Save"][language]}
            </button>
          </div>
        )}
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "25px 27px 0px 27px",
        }}
      >
        <div
          style={{
            border: "1px solid #D3B572",
            backgroundColor: "#FFFAEC",
            padding: "8px 16px",
            borderRadius: "20px",
            fontSize: "12px",
            marginBottom: "20px",
            color: "#6C5D3A"
          }}
        >
          {parseRichText(dict["Select at least one Point Layer to filter the objects."][language])}
        </div>

      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          margin: "0px 27px",
        }}
      >

        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Filter Your Data"][language]}</span>
          <hr style={{ height: "1px", backgroundColor: "#BABABA", opacity: 0.2, marginTop: "10px" }} />
        </div>


        <div style={{ display: 'flex', flexDirection: "column", gap: "10px" }}>
          <span >{dict["Choose your layer"][language]} (Point)</span>
          <Dropdown
            placeholder={dict["Select"][language]}
            filter_on
            is_enable_empty={false}
            onChange={(value) => {
              update_poi_inside_polygons(value)
            }}
            option_style={{
              maxWidth: "270px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              display: "inline-block"
            }}
          >
            {point_layers?.map((layer) => {
              return (
                <option key={layer?.geo_layer?._id} value={layer?.geo_layer?._id}>
                  {layer?.geo_layer?.name}
                </option>
              );
            })}
          </Dropdown>

          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "5px", marginTop: "10px", maxHeight: "150px", overflowY: "auto" }}>
            {point_layers
              ?.filter(l => layer_ids_poi.includes(l.geo_layer._id))
              ?.map(l => selected_pill(l.geo_layer._id, l.geo_layer.name, update_poi_inside_polygons))}
          </div>

        </div>


        <div>
          <ProgressBarButton
            is_disabled={
              !features.some(f => selected_row_toolbox_ids.includes(f.properties.uuid)) ||
              layer_ids_poi?.length === 0
            }
            progress={progress_get_data_poi}
            is_loading={is_loading_get_data_poi}
            onClick={() => {
              get_features_poi();
            }}
            onAbort={() => {
              if (abortRef.current) {
                abortRef.current.abort();
              }
            }}
          >
            {dict["Generate"][language]}
          </ProgressBarButton>
        </div>
      </section >

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "20px 0px 15px 0px",
        }}
      >
        <div
          style={{
            margin: "0px 27px 0px 27px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <label
              style={{ fontWeight: 700, fontSize: "1.125rem" }}
            >
              {dict["Filtering Result"][language]}
            </label>
            <button
              className="button_pill background_black"
              onClick={clear_data_poi}
            >
              {dict["Clear"][language]}
            </button>
          </div>
          <hr style={{ height: "1px", marginTop: "10px", backgroundColor: "#BABABA", opacity: 0.1 }} />
        </div>


        {/* <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "10px",
            margin: "0 27px 0px 27px",
          }}
        >
          <SolidCheckbox
            id="select_all"
            checked={selected_all}
            onChange={() => on_select_all()}
            style={{ width: "18px", height: "18px", cursor: "pointer" }}
          />
          <label
            htmlFor="select_all"
            style={{ fontSize: "14px", cursor: "pointer" }}
          >
            Select all
          </label>
        </div> */}

        {features.length > 0 && mode_toolbox !== "grouping" && (
          <div
            style={{ maxHeight: "200px", overflowY: "auto", position: "relative" }}
          >
            <table
              className="toolbox_table"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  {/* <th>{dict["Select"][language]}</th> */}
                  <th>No.</th>
                  <th>ID Tool</th>
                  <th>Total POI</th>
                  {/* {
                    fields.map(field => (
                      <th
                        key={field.key}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {field.name}</th>
                    ))
                  } */}
                </tr>
              </thead>
              <tbody>
                {features.filter(i => selected_row_toolbox_ids.includes(i.properties.uuid)).map((item, idx) => {
                  return (
                    <React.Fragment key={idx}>
                      <tr
                        style={{ backgroundColor: last_saved_feature_uuid_index < idx ? "lightGrey" : "white" }}
                        onClick={() => fly_to(item.properties.uuid)}
                      >
                        <td>{idx + 1}</td>
                        <td>{item?.properties?.id_tool}</td>
                        <td>{Array.isArray(poi_inside_polygons?.[item?.properties?.uuid]) ? poi_inside_polygons?.[item?.properties?.uuid]?.length : "-"}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {selected_row_toolbox_ids?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "15px",
              marginRight: "10px",
            }}
          >
            {/* <button
              onClick={() => on_clear_select()}
              className="button_pill button_white"
            >
              Cancel
            </button>

            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <button
                onClick={() => set_modal_delete(true)}
                className="button_pill flex"
                style={{
                  backgroundColor: "#BD0000",
                  color: "white",
                }}
              >
                <img src={icon_trash} alt="Delete" />
                Delete
              </button> */}
            <button
              onClick={() => set_modal_save_poi(true)}
              title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Points"][language]}`}
              className="button_pill flex"
              style={{
                backgroundColor: "black",
                color: "white",
              }}
            >
              {dict["Save"][language]}
            </button>
            {/* </div> */}
          </div>
        )}
      </section>
      {modal_delete_content}
      {modal_save_content}
      {modal_mapid_data_content}
      {modal_save_poi_content}
    </>
  );
}

export default TOOLBOX_DETAIL_RADIUS;